import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TourDateChangeService {
  private tourDate = new BehaviorSubject<moment.Moment>(null);
  private unassignedCheck = new BehaviorSubject<boolean>(false);

  private atelierDate = new BehaviorSubject<moment.Moment>(null);
  private atelierEmployeeId = new BehaviorSubject<number>(null);

  private reviewDate = new BehaviorSubject<moment.Moment>(null);
  private reviewEmployeeId = new BehaviorSubject<number>(null);

  public getTourDateSubject(): BehaviorSubject<moment.Moment> {
    return this.tourDate;
  }

  public getUnassignedCheck(): BehaviorSubject<boolean> {
    return this.unassignedCheck;
  }

  public getAtelierDateSubject(): BehaviorSubject<moment.Moment> {
    return this.atelierDate;
  }

  public getAtelierEmployeeId(): BehaviorSubject<number> {
    return this.atelierEmployeeId;
  }

  public getReviewDateSubject(): BehaviorSubject<moment.Moment> {
    return this.reviewDate;
  }

  public getReviewEmployeeId(): BehaviorSubject<number> {
    return this.reviewEmployeeId;
  }
}
